import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";

import {
  homeConstants,
  propertyConstants,
  subscriptionConstants,
  GUEST_SCROLL_LOGIN_THRESHOLD,
  GUEST_LOGIN_PROMPT_KEY,
  GUEST_LOGIN_PROMPT_SHOWN,
} from "../../constants";
import MainSpinner from "../../shared/components/spinner/MainSpinner";
import MainContentWrapper from "../../shared/components/main-content-wrapper/MainContentWrapper";
import { authActions } from "../../redux/actions";
import Topbar from "../../layout/Topbar";
import Footer from "../../layout/Footer";
import FreshProperty from "../property/FreshProperty";
import PropertyType from "../property-type/PropertyType";
import CountryBanner from "../country-banner/CountryBanner";
import FavouritesProperty from "../property/FavouritesProperty";
import RecommendedProperty from "../property/RecommendedProperty";

const { ALL_PROPERTY_TYPES } = propertyConstants;
const { GET_USER_SUBSCRIPTION_STATUS } = subscriptionConstants;
const { ALL_ALLOWED_COUNTRIES, ALL_MUST_HAVE_AMMENITIES } = homeConstants;

const hasGuestLoginPromptBeenShown = () =>
  sessionStorage.getItem(GUEST_LOGIN_PROMPT_KEY) === GUEST_LOGIN_PROMPT_SHOWN;

const markGuestLoginPromptShown = () => {
  sessionStorage.setItem(GUEST_LOGIN_PROMPT_KEY, GUEST_LOGIN_PROMPT_SHOWN);
};

const Home = ({ spinnerActions, isAuthenticated, openAuthModal }) => {
  const [amenities, setAmenities] = useState([]);
  const [filters, setFilters] = useState({
    countryIds: [],
    propertyTypeIds: [],
  });

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  // Show login modal once after the guest scrolls
  useEffect(() => {
    if (isAuthenticated || hasGuestLoginPromptBeenShown()) {
      return undefined;
    }

    const handleScroll = () => {
      if (window.scrollY >= GUEST_SCROLL_LOGIN_THRESHOLD) {
        markGuestLoginPromptShown();
        openAuthModal();
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isAuthenticated, openAuthModal]);

  return (
    <>
      {(spinner(ALL_PROPERTY_TYPES) > -1 ||
        spinner(ALL_ALLOWED_COUNTRIES) > -1 ||
        spinner(ALL_MUST_HAVE_AMMENITIES) > -1 ||
        spinner(GET_USER_SUBSCRIPTION_STATUS) > -1) &&
        isAuthenticated && <MainSpinner />}

      <Topbar />
      <MainContentWrapper>
        {isAuthenticated && (
          <CountryBanner filters={filters} setFilters={setFilters} />
        )}
        <PropertyType
          filters={filters}
          setFilters={setFilters}
          setAmenities={setAmenities}
        />
        <FreshProperty filters={filters} />
        <RecommendedProperty filters={filters} amenities={amenities} />
        {isAuthenticated && <FavouritesProperty filters={filters} />}
        <Footer />
      </MainContentWrapper>
    </>
  );
};

const mapStateToProps = (state) => ({
  spinnerActions: state.systemReducer.spinnerActions,
  isAuthenticated: state.authReducer.isAuthenticated,
});

const mapDispatchToProps = (dispatch) => ({
  openAuthModal: () => dispatch(authActions.openAuthModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
